//app.js 
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import { Suspense } from 'react';
import { lazyConReintento } from './Utils/lazyConReintento';
import CargandoPantalla from './Utils/CargandoPantalla';


import Login from './Login-Acceso/Login';
import OlvidoPassword from './Login-Acceso/OlvidoPassword';
import DashboardLayout from './Layouts/DashboardLayout';
import CambiaPasswordInic from './Login-Acceso/CambiaPassword_Inic';


// Tus páginas que irán dentro del dashboard SIN VALIDACION DE PROGRAMA
const Inicio = lazyConReintento(() => import('./Login-Acceso/Inicio'));
const CambiaPassword = lazyConReintento(() => import('./Login-Acceso/CambiaPassword'));
const CambiaRegional = lazyConReintento(() => import('./Login-Acceso/CambiaRegional'));
const Acerca = lazyConReintento(() => import('./Ayuda/Acerca'));
const Terminos = lazyConReintento(() => import('./Ayuda/Terminos'));

// Comercial
const Clientes = lazyConReintento(() => import('./Comercial/Forms/Clientes'));
const Cuentas = lazyConReintento(() => import('./Comercial/Forms/Cuentas'));
const CentrosCosto = lazyConReintento(() => import('./Comercial/Forms/CentrosCosto'));
const ConvenioComercial = lazyConReintento(() => import('./Comercial/Forms/ConvenioComercial'));
const ConvenioComercialCubrEsp = lazyConReintento(() => import('./Comercial/Forms/ConvenioComercialCubrEsp'));
const ConvenioComercialVolProduccion = lazyConReintento(() => import('./Comercial/Forms/ConvenioComercialVolProduccion'));
const CubrimientoCuenta = lazyConReintento(() => import('./Comercial/Forms/CubrimientoCuenta'));
const ConveniosRecoleccion = lazyConReintento(() => import('./Comercial/Forms/ConveniosRecoleccion'));
const ClonarCuenta = lazyConReintento(() => import('./Comercial/Forms/ClonarCuenta'));

// Operaciones
//                Procesos
const CapturaGuia = lazyConReintento(() => import('./Operaciones/Procesos/CapturaGuia'));
const SubeGuias = lazyConReintento(() => import('./Operaciones/Procesos/SubeGuias'));
const SubePedidos = lazyConReintento(() => import('./Operaciones/Procesos/SubePedidos'));
const GuiasPedidos = lazyConReintento(() => import('./Operaciones/Procesos/GuiasPedidos'));
const CapturaPedidos = lazyConReintento(() => import('./Operaciones/Procesos/CapturaPedidos'));
const ImprimeGuias = lazyConReintento(() => import('./Operaciones/Procesos/ImprimeGuias'));
const AnulaGuias = lazyConReintento(() => import('./Operaciones/Procesos/AnulaGuias'));
const CambiaFechaDespacho = lazyConReintento(() => import('./Operaciones/Procesos/CambiaFechaDespacho'));
const ActValoresDespacho = lazyConReintento(() => import('./Operaciones/Procesos/ActValoresDespacho'));
const AnulaPedidos = lazyConReintento(() => import('./Operaciones/Procesos/AnulaPedidos'));
const AjusteGuia = lazyConReintento(() => import('./Operaciones/Procesos/AjusteGuia'));
const ConfirmarProduccion = lazyConReintento(() => import('./Operaciones/Procesos/ConfirmarProduccion'));

//                Recoleccion
const OrdenRecoleccion = lazyConReintento(() => import('./Operaciones/Recoleccion/OrdenRecoleccion'));
const PlanillaRecoleccion = lazyConReintento(() => import('./Operaciones/Recoleccion/PlanillaRecoleccion'));
const MonitorRecoleccion = lazyConReintento(() => import('./Operaciones/Recoleccion/MonitorRecoleccion'));
const CierrePlanillaRecoleccion = lazyConReintento(() => import('./Operaciones/Recoleccion/CierrePlanillaRecoleccion'));
const RecoleccionPuntoVenta = lazyConReintento(() => import('./Operaciones/Recoleccion/RecoleccionPuntoVenta'));
const AsignaGuiasPR = lazyConReintento(() => import('./Operaciones/Recoleccion/AsignaGuiasPR'));
//                Despacho
const RelacionViaje = lazyConReintento(() => import('./Operaciones/Despachos/RelacionViaje'));
const CierreRelacionViaje = lazyConReintento(() => import('./Operaciones/Despachos/CierreRelacionViaje'));
const ManifiestoCarga = lazyConReintento(() => import('./Operaciones/Despachos/ManifiestoCarga'));
const LegalizacionRNDC = lazyConReintento(() => import('./Operaciones/Despachos/LegalizacionRNDC'));
//                Reparto
const PlanillaReparto = lazyConReintento(() => import('./Operaciones/Reparto/PlanillaReparto'));
const CierrePlanillaReparto = lazyConReintento(() => import('./Operaciones/Reparto/CierrePlanillaReparto'));
const MonitorCitasAgendadas = lazyConReintento(() => import('./Operaciones/Reparto/MonitorCitasAgendadas'));
const CierrePlanillaRepartoMas = lazyConReintento(() => import('./Operaciones/Reparto/CierrePlanillaRepartoMas'));

// Servicliente
//                Gestiones y Soluciones
const GuiasEnNovedad = lazyConReintento(() => import('./Servicliente/GestionesSoluciones/GuiasEnNovedad'));
const GestionesANovedades = lazyConReintento(() => import('./Servicliente/GestionesSoluciones/GestionesANovedades'));
const GestionesANovedadesMasivo = lazyConReintento(() => import('./Servicliente/GestionesSoluciones/GestionesANovedadesMasivo'));
const AgendamientoPedidos = lazyConReintento(() => import('./Servicliente/GestionesSoluciones/AgendamientoPedidos'));
const AgendamientoPedidosMasivo = lazyConReintento(() => import('./Servicliente/GestionesSoluciones/AgendamientoPedidosMasivo'));
const ProcesosAjuste = lazyConReintento(() => import('./Servicliente/GestionesSoluciones/ProcesosAjuste'));
const IOMalla = lazyConReintento(() => import('./Servicliente/GestionesSoluciones/IOMalla'));

//                Consultas
const Consultor = lazyConReintento(() => import('./Servicliente/Consultas/Consultor'));
const Cotizador = lazyConReintento(() => import('./Servicliente/Consultas/Cotizador'));
const DescargaImagenes = lazyConReintento(() => import('./Servicliente/Consultas/DescargaImagenes'));

//                Procesos
const DigitalizacionGuias = lazyConReintento(() => import('./Servicliente/Procesos/DigitalizacionGuias'));
const LoteoGuias = lazyConReintento(() => import('./Servicliente/Procesos/LoteoGuias'));
const SubeCartaportes = lazyConReintento(() => import('./Servicliente/Procesos/SubeCartaportes'));

// Inventarios
const ProductosCuenta = lazyConReintento(() => import('./Inventarios/Forms/ProductosCuenta'));
const IngresoSalidaM = lazyConReintento(() => import('./Inventarios/Forms/IngresoSalidaM'));
//import TrasladoBodegas from './Inventarios/Forms/TrasladoBodegas';
const ConsultaProductos = lazyConReintento(() => import('./Inventarios/Forms/ConsultaProductos'));
const ImportaProductos = lazyConReintento(() => import('./Inventarios/Forms/ImportaProductos'));

// Contable
//                Pre facturacion
const ReliquidacionGuias = lazyConReintento(() => import('./Contable/PreFacturacion/ReliquidacionGuias'));
const ConfirmaFacturacion = lazyConReintento(() => import('./Contable/PreFacturacion/ConfirmaFacturacion'));
const AjusteGuiaFact = lazyConReintento(() => import('./Contable/PreFacturacion/AjusteGuiaFact'));
const LiquidacionManual = lazyConReintento(() => import('./Contable/PreFacturacion/LiquidacionManual'));
const AtaGuiasFacturaExterna = lazyConReintento(() => import('./Contable/PreFacturacion/AtaGuiasFacturaExterna'));
//                Facturacion
const PreFactura = lazyConReintento(() => import('./Contable/Facturacion/PreFactura'));
const AnulaPreFactura = lazyConReintento(() => import('./Contable/Facturacion/AnulaPreFactura'));
//                Recaudos
const DescargaFacCredito = lazyConReintento(() => import('./Contable/Recaudos/DescargaFacCredito'));
//import DescargaFacCredito from './Contable/Recaudos/DescargaFacCredito';
//import DescargaFacCredito from './Contable/Recaudos/DescargaFacCredito';

// Administracion
//                Usuarios
const Usuarios = lazyConReintento(() => import('./Administracion/AdminUsuarios/Usuarios'));
const ResetPassword = lazyConReintento(() => import('./Administracion/AdminUsuarios/ResetPassword'));
//                Tablas Operativas
const Ciudades = lazyConReintento(() => import('./Administracion/TablasOperativas/Ciudades'));
const Cubrimiento = lazyConReintento(() => import('./Administracion/TablasOperativas/Cubrimiento'));
const Oficinas = lazyConReintento(() => import('./Administracion/TablasOperativas/Oficinas'));
const DiasFestivos = lazyConReintento(() => import('./Administracion/TablasOperativas/DiasFestivos'));
const Zonas = lazyConReintento(() => import('./Administracion/TablasOperativas/Zonas'));
//                Recurso Operativo
const PropietariosTenedores = lazyConReintento(() => import('./Administracion/RecursoOperativo/PropietariosTenedores'));
const Colores = lazyConReintento(() => import('./Administracion/RecursoOperativo/Colores'));
const Marcas = lazyConReintento(() => import('./Administracion/RecursoOperativo/Marcas'));
const MarcaLineas = lazyConReintento(() => import('./Administracion/RecursoOperativo/MarcaLineas'));
const TiposCarrocerias = lazyConReintento(() => import('./Administracion/RecursoOperativo/TiposCarrocerias'));
const Vehiculos = lazyConReintento(() => import('./Administracion/RecursoOperativo/Vehiculos'));
const Moviles = lazyConReintento(() => import('./Administracion/RecursoOperativo/Moviles'));
//                Identidad Corporativa
const IdentidadCorporativa = lazyConReintento(() => import('./Administracion/IdentidadCorporativa'));

// Utiles
const Jobs = lazyConReintento(() => import('./Utiles/Jobs'));
const DescargaFormatos = lazyConReintento(() => import('./Utiles/DescargaFormatos'));
const Construccion = lazyConReintento(() => import('./Utiles/Construccion'));
const EditorDirecciones = lazyConReintento(() => import('./Utiles/EditorDirecciones'));



// Informes
const Reporteador = lazyConReintento(() => import('./Informes/Reporteador'));
const RutaMensajero = lazyConReintento(() => import('./Informes/RutaMensajero'));


function App() {
  return (
    <Router>
      <Suspense fallback={<CargandoPantalla />}>
      <Routes>
        {/* Página pública */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        <Route path="/login" element={<Login />} />

        <Route path="/OlvidoPassword" element={<OlvidoPassword />} />

        <Route path="/EditorDirecciones" element={<EditorDirecciones />} />

        <Route
          path="/CambiaPassword_Inic"
          element={<CambiaPasswordInic />}
        />

        {/* Páginas privadas dentro del layout */}
        <Route path="/" element={<DashboardLayout />}>

          <Route path="/Inicio" element={<Inicio />} />
          <Route path="/CambiaPassword" element={<CambiaPassword />} />
          <Route path="/CambiaRegional" element={<CambiaRegional />} />
          <Route path="/Acerca" element={<Acerca />} />
          <Route path="/Terminos" element={<Terminos />} />

          {/* Comercial */}
          <Route path="/Clientes" element={<Clientes />} />
          <Route path="/Cuentas" element={<Cuentas />} />
          <Route path="/CentrosCosto" element={<CentrosCosto />} />
          <Route path="/ConvenioComercial" element={<ConvenioComercial />} />
          <Route path="/ConvenioComercialCubrEsp" element={<ConvenioComercialCubrEsp />} />
          <Route path="/ConvenioComercialVolProduccion" element={<ConvenioComercialVolProduccion />} />
          <Route path="/CubrimientoCuenta" element={<CubrimientoCuenta />} />
          <Route path="/ConveniosRecoleccion" element={<ConveniosRecoleccion />} />
          <Route path="/ClonarCuenta" element={<ClonarCuenta />} />

          {/* Operaciones */}
          {/*               Procesos */}
          <Route path="/CapturaGuia" element={<CapturaGuia />} />
          <Route path="/SubeGuias" element={<SubeGuias />} />
          <Route path="/SubePedidos" element={<SubePedidos />} />
          <Route path="/CapturaPedidos" element={<CapturaPedidos />} />
          <Route path="/GuiasPedidos" element={<GuiasPedidos />} />
          <Route path="/ImprimeGuias" element={<ImprimeGuias />} />
          <Route path="/AnulaGuias" element={<AnulaGuias />} />
          <Route path="/CambiaFechaDespacho" element={<CambiaFechaDespacho />} />
          <Route path="/ActValoresDespacho" element={<ActValoresDespacho />} />
          <Route path="/AnulaPedidos" element={<AnulaPedidos />} />
          <Route path="/AjusteGuia" element={<AjusteGuia />} />
          <Route path="/ConfirmarProduccion" element={<ConfirmarProduccion />} />
          
          {/*               Recoleccion */}
          <Route path="/OrdenRecoleccion" element={<OrdenRecoleccion />} />
          <Route path="/PlanillaRecoleccion" element={<PlanillaRecoleccion />} />
          <Route path="/MonitorRecoleccion" element={<MonitorRecoleccion />} />
          <Route path="/CierrePlanillaRecoleccion" element={<CierrePlanillaRecoleccion />} />
          <Route path="/RecoleccionPuntoVenta" element={<RecoleccionPuntoVenta />} />
          <Route path="/AsignaGuiasPR" element={<AsignaGuiasPR />} />
          {/*               Despacho */}
          <Route path="/RelacionViaje" element={<RelacionViaje />} />
          <Route path="/CierreRelacionViaje" element={<CierreRelacionViaje />} />
          <Route path="/ManifiestoCarga" element={<ManifiestoCarga />} />
          <Route path="/LegalizacionRNDC" element={<LegalizacionRNDC />} />
          {/*               Reparto */}
          <Route path="/PlanillaReparto" element={<PlanillaReparto />} />
          <Route path="/CierrePlanillaReparto" element={<CierrePlanillaReparto />} />
          <Route path="/MonitorCitasAgendadas" element={<MonitorCitasAgendadas />} />
          <Route path="/CierrePlanillaRepartoMas" element={<CierrePlanillaRepartoMas />} />


          {/* Servicliente */}
          {/*               Gestiones y Soluciones */}
          <Route path="/GuiasEnNovedad" element={<GuiasEnNovedad />} />
          <Route path="/GestionesANovedades" element={<GestionesANovedades />} />
          <Route path="/GestionesANovedadesMasivo" element={<GestionesANovedadesMasivo />} />
          <Route path="/AgendamientoPedidos" element={<AgendamientoPedidos />} />
          <Route path="/AgendamientoPedidosMasivo" element={<AgendamientoPedidosMasivo />} />
          <Route path="/ProcesosAjuste" element={<ProcesosAjuste />} />
          <Route path="/IOMalla" element={<IOMalla />} />

          {/*               Consultas */}
          <Route path="/Consultor" element={<Consultor />} />
          <Route path="/Cotizador" element={<Cotizador />} />
          <Route path="/DescargaImagenes" element={<DescargaImagenes />} />

          {/*               Procesos */}
          <Route path="/DigitalizacionGuias" element={<DigitalizacionGuias />} />
          <Route path="/LoteoGuias" element={<LoteoGuias />} />
          <Route path="/SubeCartaportes" element={<SubeCartaportes />} />


          {/* Inventarios */}
          <Route path="/ProductosCuenta" element={<ProductosCuenta />} />
          <Route path="/IngresoSalidaM" element={<IngresoSalidaM />} />
          {/*<Route path="/TrasladoBodegas" element={<TrasladoBodegas />} />*/}
          <Route path="/ConsultaProductos" element={<ConsultaProductos />} />
          <Route path="/ImportaProductos" element={<ImportaProductos />} />

          {/* Contable */}
          {/*               PreFacturacion */}
          <Route path="/ReliquidacionGuias" element={<ReliquidacionGuias />} />
          <Route path="/ConfirmaFacturacion" element={<ConfirmaFacturacion />} />
          <Route path="/AjusteGuiaFact" element={<AjusteGuiaFact />} />
          <Route path="/LiquidacionManual" element={<LiquidacionManual />} />
          <Route path="/AtaGuiasFacturaExterna" element={<AtaGuiasFacturaExterna />} />
          {/*               Facturacion */}
          <Route path="/PreFactura" element={<PreFactura />} />
          <Route path="/AnulaPreFactura" element={<AnulaPreFactura />} />
          {/*               Recaudos */}
          <Route path="/DescargaFacCredito" element={<DescargaFacCredito />} />
          {/* <Route path="/DescargaFacCredito" element={<DescargaFacCredito />} /> */}
          {/* <Route path="/DescargaFacCredito" element={<DescargaFacCredito />} /> */}

          {/* Administracion */}
          {/*               Usuarios */}
          <Route path="/Usuarios" element={<Usuarios />} />
          <Route path="/ResetPassword" element={<ResetPassword />} />
          {/*               Tablas Operativas */}
          <Route path="/Ciudades" element={<Ciudades />} />
          <Route path="/Cubrimiento" element={<Cubrimiento />} />
          <Route path="/Oficinas" element={<Oficinas />} />
          <Route path="/DiasFestivos" element={<DiasFestivos />} />
          <Route path="/Zonas" element={<Zonas />} />
          {/*               Recurso Operativo */}
          <Route path="/PropietariosTenedores" element={<PropietariosTenedores />} />
          <Route path="/Colores" element={<Colores />} />
          <Route path="/Marcas" element={<Marcas />} />
          <Route path="/MarcaLineas" element={<MarcaLineas />} />
          <Route path="/TiposCarrocerias" element={<TiposCarrocerias />} />
          <Route path="/Vehiculos" element={<Vehiculos />} />
          <Route path="/Moviles" element={<Moviles />} />
          <Route path="/IdentidadCorporativa" element={<IdentidadCorporativa />} />

          {/* Utiles */}
          <Route path="/Jobs" element={<Jobs />} />
          <Route path="/DescargaFormatos" element={<DescargaFormatos />} />
          <Route path="/Construccion" element={<Construccion />} />
          
         
          {/* Informes */}
           <Route path="/Reporteador" element={<Reporteador />} />
          <Route path="/RutaMensajero" element={<RutaMensajero />} />


        </Route>
      </Routes>
      </Suspense>
    </Router>
  );
}

export default App;

